/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Consumption_DescriptionInputs */



/**
* | output |
* | --- |
* | "Electricity, gas, water, heat: find your meters and sub-meters, compare periods and export your data." |
*
* @param {Go_Further_Consumption_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_consumption_description = /** @type {((inputs?: Go_Further_Consumption_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Consumption_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Electricity, gas, water, heat: find your meters and sub-meters, compare periods and export your data.")
	return /** @type {LocalizedString} */ ("Électricité, gaz, eau, calories : retrouvez vos compteurs et sous-compteurs, comparez les périodes et exportez vos données.")
});